import proj4 from 'proj4';
import {register} from 'ol/proj/proj4';
import {get} from 'ol/proj';

/**
 * Register the projection EPSG:3857 with proj4.
 */
export const projection = {

  /**
   * projection definition
   * WGS 84 / Pseudo-Mercator -- Spherical Mercator
   * @see https://epsg.io/3857
   * @type {String}
   */
  definition: '+proj=merc +a=6378137 +b=6378137 +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +k=1 +units=m +nadgrids=@null +wktext +no_defs +type=crs',

  /**
   * projection name
   * @type {String}
   */
  name: 'EPSG:3857',

  /** @type {Object} */
  _projection: null,

  /**
   * projected bounds
   */
  extent: [663464, 5751550, 1167741, 6075303],

  /**
   * center coordinates
   */
  center: [915602.8072104596, 5911929.4687797595],

  /**
   * Register and return the projection.
   * @return {Object} projection
   */
  get() {
    if (this._projection === null) {
      this._init();

    }

    return this._projection;
  },

  /**
   * Initialize the projection
   * @private
   */
  _init(){
    proj4.defs(this.name, this.definition);
    register(proj4);
    this._projection = get(this.name);
    this._projection.setExtent(this.extent);
  }
};